import React, { useCallback, useState } from 'react';
import _ from 'lodash';
import classNames from 'classnames';
import ReactTooltip from 'react-tooltip';
import { translate } from '../../../../../javascript/utils/i18n';

const ColumnHeader = ({
  columns,
  query,
  tableId,
  columnKey,
  setOrder,
  orderColumn,
  orderAscending
}) => {
  const currentColumn = columns[columnKey];

  if(currentColumn == null)
    return null;

  const headerTooltip = currentColumn.header_tooltip;
  const headerTooltipText = _.isString(headerTooltip) ? headerTooltip : _.get(headerTooltip, 'text');
  const headerTooltipIcon = _.get(headerTooltip, 'icon', 'info-circle');

  const [direction, setDirection] = useState('ascending');
  const [hoverColumn, setHoverColumn] = useState(null);

  // TODO: this is a hack to allow showing both order and filter options in the
  // table. We should refactor table_on_steroids to allow an array of permitted
  // actions.
  const arOrderLambda = _.at(currentColumn, 'activerecord.order_lambda');
  const arrayOrderLambda = _.at(currentColumn, 'array.order_lambda');
  const isOrderable =
    currentColumn.type === 'order' ||
    (arOrderLambda && arOrderLambda[0]) ||
    (arrayOrderLambda && arrayOrderLambda[0]);
  const className = _([
    'column',
    `column-${columnKey}`,
    currentColumn.css_class,
    isOrderable ? 'order' : 'no-order',
  ])
    .compact()
    .value()
    .join(' ');
  const orderIsActive = orderColumn === columnKey;

  const handleClick = useCallback(() => {
    if (isOrderable)
      setOrder(columnKey, ((orderAscending && orderIsActive) ? 'descending' : 'ascending'));
    else
      null;
  }, [direction]);

  const handleHoverEvent = (hover, column) => {

    if (hover)
      setHoverColumn(column);
    else {
      setDirection(orderAscending ? "ascending" : "descending");
      setHoverColumn(null);
    }

    if (hover && orderAscending && orderIsActive)
      setDirection("descending");
    else if ((hover && !orderAscending && orderIsActive) || orderIsActive)
      setDirection("ascending");

  };

  return (
    <th
      className={className}
      onMouseEnter={() => handleHoverEvent(true, columnKey)}
      onMouseLeave={() => handleHoverEvent(false, columnKey)}
      onClick={() => handleClick()}
    >
      <div
        className={classNames(
          'd-flex',
          'align-items-left',
          'justify-content-left',
          { 'sortable-column': isOrderable }
        )}
      >
        <label className="mr-1 eyebrow">
          {translate(currentColumn.label)}
        </label>
        {headerTooltipText ? (
          <span
            className={classNames('fa', `fa-${headerTooltipIcon}`, 'ml-1', 'text-muted')}
            data-tip={headerTooltipText}
            data-place="bottom"
          >
            <ReactTooltip
              className="table-on-steroids-header-tooltip"
              effect="solid"
              backgroundColor="#fff"
              textColor="#4f6f99"
              border
              borderColor="#d7e4f2"
              arrowColor="#fff"
            />
          </span>
        ) : null}
        {isOrderable && (
          <div className="table-on-steroids-sorting-icon d-flex align-items-center" style={{ width: 12 }}>
            <i className={`fa fa-sort-down ${((orderIsActive && hoverColumn != columnKey && !orderAscending) || (hoverColumn == columnKey && direction == 'descending')) ? '' : 'table-on-steroids-sorting-icon-hidden'}`} />
            <i className={`fa fa-sort-up ${((orderIsActive && hoverColumn != columnKey && orderAscending) || (hoverColumn == columnKey && direction == 'ascending')) ? '' : 'table-on-steroids-sorting-icon-hidden'}`} />
          </div>
        )}
      </div>
    </th>
  );
};

const TableHeader = ({ selectedColumns, ...props }) => (
  <React.Fragment>
    {selectedColumns.map(columnKey => (
      <ColumnHeader key={columnKey} {...props} columnKey={columnKey} />
    ))}
  </React.Fragment>
);

export default TableHeader;
